import { render, staticRenderFns } from "./tournamentList_v2.vue?vue&type=template&id=e885ac1e&"
import script from "./tournamentList_v2.vue?vue&type=script&lang=js&"
export * from "./tournamentList_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports